<template>
    <div class="form-modal-ct">
        <el-dialog v-model="formVisibility"
                   :title="formTitle"
                   :close-on-click-modal="false"
                   :close-on-press-escape="false"
                   style="max-width: 650px;"
                   @open="onDialogOpen"
                   @close="clearForm">

            <template #default>
                <el-form ref="ruleFormRef"
                         :rules="rules"
                         :model="formModel">
                    <div class="modal-body py-10 px-lg-17">
                        <div class="scroll-y me-n7 pe-7"
                             id="kt_modal_add_customer_scroll"
                             data-kt-scroll="true"
                             data-kt-scroll-activate="{default: false, lg: true}"
                             data-kt-scroll-max-height="auto"
                             data-kt-scroll-dependencies="#kt_modal_add_customer_header"
                             data-kt-scroll-wrappers="#kt_modal_add_customer_scroll"
                             data-kt-scroll-offset="300px">

                            <slot>
                                <!-- TEMPLATES DO COMPONENTE FORMUL�RIO -->
                            </slot>

                        </div>
                    </div>

                </el-form>
            </template>
            <template #footer>
                <span class="dialog-footer">
                    <el-button type="info"
                               id="modal_form_cancel"
                               data-bs-dismiss="modal"
                               aria-label="Close"
                               @click="closeModal"
                               plain>
                        {{ cancelText }}
                    </el-button>

                    <el-button type="success" @click="submit(ruleFormRef)">
                        {{ saveText }}
                    </el-button>
                </span>
            </template>
        </el-dialog>
    </div>
</template>
<script lang="ts">
    import { ElForm } from 'element-plus';
    import { ref, nextTick } from 'vue';

    export default {
        props: {
            formTitle: {
                type: String,
                default: () => {
                    return 'Cadastro'
                }
            },

            cancelText: {
                type: String,
                default: () => {
                    return 'Cancelar'
                }
            },

            saveText: {
                type: String,
                default: () => {
                    return 'Salvar'
                }
            },

            rules: {
                type: Object,
                default: () => {
                    return {}
                }
            },

            formModel: {
                type: Object,
                default: () => {
                    return {}
                }
            },
        },

        emit: ["submit", "closeForm"],

        setup(props, { emit }) {
            type formInstance = InstanceType<typeof ElForm>;
            const ruleFormRef = ref<formInstance>();
            const formVisibility = ref(false);

            // submit function
            const submit = (formEl: formInstance | undefined) => {
                if (!formEl) return
                formEl.validate(valid => {
                    if (valid) {
                        emit('submit');
                    } else {
                        return false
                    }
                });
            };            

            const openModal = () => {
                formVisibility.value = true;
            }

            const closeModal = () => {
                formVisibility.value = false;

                clearForm();
            }

            // Disparado pelo @open do el-dialog: limpa validação após o el-form
            // montar, garantindo que toda abertura comece sem mensagens "presas".
            const onDialogOpen = () => {
                nextTick(() => {
                    let form = ruleFormRef.value as formInstance;
                    if (form && form.clearValidate)
                        form.clearValidate();
                });
            };

            // clear form function
            const clearForm = () => {
                let form = ruleFormRef.value as formInstance;
                // resetFields() limpa os valores; clearValidate() remove as
                // mensagens de erro (evita validação "presa" ao reabrir).
                if (form) {
                    if (form.resetFields) form.resetFields();
                    if (form.clearValidate) form.clearValidate();
                }
                emit('closeForm');
            };

            return {
                ruleFormRef,
                formVisibility,

                submit,
                clearForm,
                onDialogOpen,

                openModal,
                closeModal,
            }
        }
    }
</script>